export const INTRO_VIDEO_URL =
  'https://img.vggcdn.net/videos/sponsoredListings/IntroductionToBoost.mp4';
